import { Routes } from '@angular/router';
import { AddressSearchComponent } from './components/address-search/address-search.component';
import { CreateVideoRequestComponent } from './components/create-video-request/create-video-request.component';
import { GpsSearchComponent } from './components/gps-search/gps-search.component';
import { HomeComponent } from './components/home/home.component';
import { PageNotFoundComponent } from './components/page-not-found/page-not-found.component';
import { UnitSearchComponent } from './components/unit-search/unit-search.component';
import { UsageReportsComponent } from './components/usage-reports/usage-reports.component';
import { VideoRequestComponent } from './components/video-request/video-request.component';
import { VideoRequestsComponent } from './components/video-requests/video-requests.component';
import { ErrorComponent } from './components/error/error.component';
import { TermsAndConditionsComponent } from './components/terms-and-conditions/terms-and-conditions.component';
import { AuthGuardService } from './services/auth-guard/auth-guard.service';
import { ConfigService } from './services/config/config.service';
import { UsageReportsAuthGuardService } from './services/auth-guard/usage-reports-auth-guard';
import { MsalGuard, MsalAngularConfiguration } from '@azure/msal-angular';
import { ConsentScopesService } from './services/config/consent-scopes.service';
// Move isIE definition before its usage in msalConfigFactory
var isIE = window.navigator.userAgent.indexOf("MSIE ") > -1 || window.navigator.userAgent.indexOf("Trident/") > -1;
export function msalConfigFactory(configService) {
    return {
        auth: {
            clientId: configService.config.clientId,
            authority: configService.config.authority,
            validateAuthority: true,
            redirectUri: window.location.origin + '/callback',
            postLogoutRedirectUri: window.location.origin,
            navigateToLoginRequestUrl: false,
        },
        cache: {
            cacheLocation: "localStorage",
            storeAuthStateInCookie: isIE,
        },
        framework: {}
    };
}
export function msalAngularConfigFactory(consentScopesService, configService) {
    var protectedResourceMap = new Map();
    var apiRoot = configService.config.apiRoot.endsWith('/') ? configService.config.apiRoot : configService.config.apiRoot + '/';
    protectedResourceMap.set(apiRoot + "*", consentScopesService.getConsentScopes());
    return {
        popUp: false,
        consentScopes: consentScopesService.getConsentScopes(),
        protectedResourceMap: protectedResourceMap
    };
}
var ɵ0 = { roles: ['jjr', 'council'], title: "Address Search" }, ɵ1 = { roles: ['jjr', 'council'], title: "Address Search" }, ɵ2 = { roles: ['jjr', 'council'] }, ɵ3 = { roles: ['jjr', 'council'], title: "Create Request" }, ɵ4 = { roles: ['jjr', 'council'], title: "GPS Search" }, ɵ5 = { roles: ['jjr', 'council'], title: "GPS Search" }, ɵ6 = { roles: ['jjr'], title: "Unit Search" }, ɵ7 = { roles: ['jjr'], title: "Unit Search" }, ɵ8 = { roles: ['jjr', 'council'], title: "Video Request" }, ɵ9 = { roles: ['jjr', 'council'], title: "Video Requests List" }, ɵ10 = { roles: ['jjr', 'council'], title: "Video Requests List" };
var appRoutes = [
    {
        path: 'address-search',
        component: AddressSearchComponent,
        canActivate: [MsalGuard, AuthGuardService],
        data: ɵ0
    },
    {
        path: 'address-search/:site',
        component: AddressSearchComponent,
        canActivate: [MsalGuard, AuthGuardService],
        data: ɵ1
    },
    {
        path: 'callback',
        component: HomeComponent,
        canActivate: [MsalGuard],
        data: ɵ2
    },
    {
        path: 'create-video-request/:truckNumber',
        component: CreateVideoRequestComponent,
        canActivate: [MsalGuard, AuthGuardService],
        data: ɵ3
    },
    {
        path: 'gps-search',
        component: GpsSearchComponent,
        canActivate: [MsalGuard, AuthGuardService],
        data: ɵ4
    },
    {
        path: 'gps-search/:site',
        component: GpsSearchComponent,
        canActivate: [MsalGuard, AuthGuardService],
        data: ɵ5
    },
    { path: 'home', component: HomeComponent },
    {
        path: 'unit-search',
        component: UnitSearchComponent,
        canActivate: [MsalGuard, AuthGuardService],
        data: ɵ6
    },
    {
        path: 'unit-search/:site',
        component: UnitSearchComponent,
        canActivate: [MsalGuard, AuthGuardService],
        data: ɵ7
    },
    {
        path: 'video-request/:requestId',
        component: VideoRequestComponent,
        canActivate: [MsalGuard, AuthGuardService],
        data: ɵ8
    },
    {
        path: 'video-requests',
        component: VideoRequestsComponent,
        canActivate: [MsalGuard, AuthGuardService],
        data: ɵ9
    },
    {
        path: 'video-requests/:vrrId',
        component: VideoRequestsComponent,
        canActivate: [MsalGuard, AuthGuardService],
        data: ɵ10
    },
    {
        path: 'usage-reports',
        component: UsageReportsComponent,
        canActivate: [MsalGuard, UsageReportsAuthGuardService],
    },
    {
        path: '',
        redirectTo: 'home',
        pathMatch: 'full'
    },
    {
        path: 'terms-and-conditions',
        pathMatch: 'full',
        component: TermsAndConditionsComponent
    },
    { path: 'error', component: ErrorComponent },
    { path: '**', component: PageNotFoundComponent }
];
var AppModule = /** @class */ (function () {
    function AppModule() {
    }
    return AppModule;
}());
export { AppModule };
export { ɵ0, ɵ1, ɵ2, ɵ3, ɵ4, ɵ5, ɵ6, ɵ7, ɵ8, ɵ9, ɵ10 };
